import { gql } from "@apollo/client";

export const GET_ALL_FRANCHISE = gql`
query GetAllFranchise($page: Int, $limit: Int, $filter: String, $sort: userSort, $search: String, $from: String, $to: String) {
  getAllFranchise(page: $page, limit: $limit, filter: $filter, sort: $sort, search: $search, from: $from, to: $to) {
    count
    data {
      _id
      username
      token
      email
      fullName
      verified
      dob
      age
      gender
      contactNo
      aadharNumber
      alternateContactNo
      panNumber
      documentType
      documentId
      aadharFront
      franchiseType
      aadharBack
      residentialAddress
      residentialPincode
      residentialCity
      residentialState
      officeAddress
      officePincode
      officeCity
      officeState
      officeTelephoneNo
      officeMainArea
      district
      state
      telephoneNo
      gstNumber
      accountName
      accountNo
      bankName
      branchAddress
      accountType
      ifscCode
      cancelChequeImage
      franchiseAgreement
      isActive
      createdAt
      branchName
      branchCity
      branchState
      gstLegalName
      getCertificate
      panCardImage
      education
      currentWork
      knowEnglishLanguagePercentage
      ApproveAgreement
      uploadAgreement
    }
  }
}
`

export const GET_ALL_RO = gql`
query GetAllRO($page: Int, $limit: Int, $filter: String, $search: String, $from: String, $to: String, $sort: userSort) {
  getAllRO(page: $page, limit: $limit, filter: $filter, search: $search, from: $from, to: $to, sort: $sort) {
    count
    data {
      _id
      username
      token
      email
      fullName
      webFcmToken
      verified
      dob
      age
      gender
      contactNo
      aadharNumber
      alternateContactNo
      panNumber
      documentType
      documentId
      aadharFront
      franchiseType
      aadharBack
      residentialAddress
      residentialPincode
      residentialCity
      residentialState
      officeAddress
      officePincode
      officeCity
      officeState
      officeTelephoneNo
      officeMainArea
      district
      state
      telephoneNo
      gstNumber
      accountName
      accountNo
      bankName
      branchAddress
      accountType
      ifscCode
      cancelChequeImage
      franchiseAgreement
      isActive
      createdAt
      branchName
      branchCity
      branchState
      gstLegalName
      getCertificate
      panCardImage
      education
      currentWork
      knowEnglishLanguagePercentage
      ApproveAgreement
      uploadAgreement
    }
  }
}
`

export const GET_ALL_FRANCHISES = gql`
  query {
    getAllFranchises {
      _id
      username
    }
  }
`;

export const ASSIGN_FRANCHISES_TO_RO = gql`
  mutation AssignFranchisesToRO($roId: ID!, $franchiseIds: [ID!]!) {
    assignFranchisesToRO(roId: $roId, franchiseIds: $franchiseIds) {
      _id
      username
      franchises {
        _id
        username
      }
    }
  }
`;

export const GET_RO_BY_ID = gql`
  query GetROById($id: ID!) {
    getROById(id: $id) {
      _id
      username
      franchises {
        _id
        username
      }
    }
  }
`;

export const GET_FRANCHISE_INQUIRY = gql`
query GetAllFranchiseInquiries($sort: orderSort, $search: String, $toDate: String, $fromDate: String, $status: String, $limit: Int, $page: Int) {
  getAllFranchiseInquiries(sort: $sort, search: $search, toDate: $toDate, fromDate: $fromDate, status: $status, limit: $limit, page: $page) {
    count
    data {
      id
      fullName
      contactNo
      preferredArea
      pincode
      city
      message
      status
      createdAt
      updatedAt
    }
  }
}
`
export const VERIFY_FRANCHISE = gql`
mutation VerifyFranchise($franchiseId: ID!) {
  verifyFranchise(franchiseId: $franchiseId) {
    _id
  }
}
`